
/**
 * 주문 유형
 */
export type OrderInfoResponseOrderType = typeof OrderInfoResponseOrderType[keyof typeof OrderInfoResponseOrderType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderInfoResponseOrderType = {
  ONE_TIME: 'ONE_TIME',
  SUBSCRIPTION: 'SUBSCRIPTION',
} as const;
